import { useCallback } from "react";
import { SupportApi, useAPIAction } from "melco-shared-logic";

export const useGetSupportToken = () => {
  const [getSupportToken] = useAPIAction(
    SupportApi,
    async (api, userId: string) => {
      const data = await api.supportGenerateToken({
        melcoModelsCreateSupportToken: {
          for_user: userId,
        },
      });
      return {
        successMessages: [],
        data,
      };
    },
    {
      translationPrefix: "",
    }
  );

  return useCallback(
    async (userId: string) => {
      try {
        let response = await getSupportToken(userId);
        //console.log(response);
        let token = response?.token ?? "";
        return { token: token, success: true };
      } catch (e) {
        return { success: false, error: e };
      }
    },
    [getSupportToken]
  );
};
